import { Button, ExceptionIcon } from "@theprelude/ds";
import { ControlCategory } from "@theprelude/sdk";
import { useOverlay } from "@/hooks/use-overlay";

export const AddObjectExceptionButton = ({
  category,
}: {
  category: ControlCategory;
}) => {
  const overlay = useOverlay();

  return (
    <Button
      intent="pill"
      size="tiny"
      icon={<ExceptionIcon className="text-secondary-foreground" />}
      onClick={() => overlay.open("add-object-exception", { category })}
    >
      Add exception
    </Button>
  );
};
